import React from "react";
import { Link } from "react-router-dom";

import {
    FaGithub,
    FaLinkedin,
    FaXTwitter
} from "react-icons/fa6";

export const Footer = () => {
    return (
        <footer className="bg-[#F8FAFC] border-t border-[#E4E9F0]">

            <div className="max-w-7xl mx-auto px-6 lg:px-8">

                {/* Main footer */}
                <div className="py-20 lg:py-24">

                    <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">

                        {/* Brand */}
                        <div>

                            <div className="flex items-center gap-3">

                                <img
                                    src="/vectors4d_logo_circuit_brain.svg"
                                    className="w-9 h-9 object-contain"
                                    alt="Vectors4D"
                                />

                                <h2 className="text-2xl font-semibold tracking-tight text-[#172033]">
                                    Vectors4D
                                </h2>

                            </div>

                            <p className="
                                mt-6
                                max-w-lg
                                text-[15px]
                                leading-7
                                text-[#687386]
                            ">
                                Artificial intelligence research and systems
                                engineering focused on machine intelligence,
                                simulation, optimization, and real-world
                                computational systems.
                            </p>

                            <div className="mt-8 flex items-center gap-5">

                                <a
                                    href="https://github.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="GitHub"
                                    className="
                                        text-[#7A8495]
                                        transition-colors
                                        hover:text-[#172033]
                                    "
                                >
                                    <FaGithub size={18} />
                                </a>

                                <a
                                    href="https://linkedin.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="LinkedIn"
                                    className="
                                        text-[#7A8495]
                                        transition-colors
                                        hover:text-[#5277E8]
                                    "
                                >
                                    <FaLinkedin size={18} />
                                </a>

                                <a
                                    href="https://x.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="X"
                                    className="
                                        text-[#7A8495]
                                        transition-colors
                                        hover:text-[#172033]
                                    "
                                >
                                    <FaXTwitter size={18} />
                                </a>

                            </div>

                        </div>


                        {/* Newsletter */}
                        <div className="lg:max-w-xl lg:ml-auto">

                            <p className="
                                text-sm
                                font-semibold
                                text-[#172033]
                            ">
                                Research notes
                            </p>

                            <h3 className="
                                mt-3
                                text-2xl
                                lg:text-3xl
                                font-medium
                                tracking-tight
                                text-[#172033]
                            ">
                                Ideas, research and systems.
                            </h3>

                            <p className="
                                mt-3
                                text-sm
                                leading-6
                                text-[#687386]
                            ">
                                Occasional updates on artificial intelligence,
                                simulation, optimization and the systems we build.
                            </p>

                            <div className="mt-6 flex flex-col sm:flex-row gap-3">

                                <input
                                    type="email"
                                    placeholder="Email address"
                                    className="
                                        flex-1
                                        h-12
                                        rounded-xl
                                        border
                                        border-[#DDE3EC]
                                        bg-white
                                        px-4
                                        text-sm
                                        text-[#172033]
                                        placeholder:text-[#9AA3B2]
                                        outline-none
                                        transition
                                        focus:border-[#5277E8]
                                        focus:ring-2
                                        focus:ring-[#5277E8]/10
                                    "
                                />

                                <button
                                    type="button"
                                    className="
                                        h-12
                                        rounded-xl
                                        bg-[#172033]
                                        px-6
                                        text-sm
                                        font-medium
                                        text-white
                                        transition-all
                                        duration-200
                                        hover:bg-[#5277E8]
                                    "
                                >
                                    Subscribe
                                </button>

                            </div>

                        </div>

                    </div>


                    {/* Links */}
                    <div className="
                        mt-20
                        pt-12
                        border-t
                        border-[#E4E9F0]
                        grid
                        sm:grid-cols-2
                        lg:grid-cols-4
                        gap-12
                    ">

                        {/* Research */}
                        <div>

                            <h4 className="
                                text-xs
                                font-semibold
                                uppercase
                                tracking-[0.16em]
                                text-[#8A94A5]
                            ">
                                Research
                            </h4>

                            <div className="mt-5 space-y-3">

                                <Link
                                    to="/ml"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Machine Learning
                                </Link>

                                <Link
                                    to="/cv"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Computer Vision
                                </Link>

                                <Link
                                    to="/nlp"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Reinforcement Learning
                                </Link>

                                <Link
                                    to="/gai"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Generative AI
                                </Link>

                            </div>

                        </div>


                        {/* Publications */}
                        <div>

                            <h4 className="
                                text-xs
                                font-semibold
                                uppercase
                                tracking-[0.16em]
                                text-[#8A94A5]
                            ">
                                Publications
                            </h4>

                            <div className="mt-5 space-y-3">

                                <Link
                                    to="/journal"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Research Journal
                                </Link>

                                <Link
                                    to="/casestudy"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Case Studies
                                </Link>

                                <Link
                                    to="/glossary"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Glossary
                                </Link>

                                <Link
                                    to="/papers"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Research Papers
                                </Link>

                            </div>

                        </div>


                        {/* Systems */}
                        <div>

                            <h4 className="
                                text-xs
                                font-semibold
                                uppercase
                                tracking-[0.16em]
                                text-[#8A94A5]
                            ">
                                Systems
                            </h4>

                            <div className="mt-5 space-y-3">

                                <Link
                                    to="/agents"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Autonomous Agents
                                </Link>

                                <Link
                                    to="/simulation"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    AI Simulation
                                </Link>

                                <Link
                                    to="/infrastructure"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    AI Infrastructure
                                </Link>

                                <Link
                                    to="/platforms"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Research Platforms
                                </Link>

                            </div>

                        </div>


                        {/* Company */}
                        <div>

                            <h4 className="
                                text-xs
                                font-semibold
                                uppercase
                                tracking-[0.16em]
                                text-[#8A94A5]
                            ">
                                Company
                            </h4>

                            <div className="mt-5 space-y-3">

                                <Link
                                    to="/about"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    About
                                </Link>

                                <Link
                                    to="/careers"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Careers
                                </Link>

                                <Link
                                    to="/contact"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    Contact
                                </Link>

                                <a
                                    href="mailto:info@vectors4d.com"
                                    className="block text-sm text-[#687386] hover:text-[#5277E8] transition-colors"
                                >
                                    info@vectors4d.com
                                </a>

                            </div>

                        </div>

                    </div>

                </div>


                {/* Bottom */}
                <div className="
                    border-t
                    border-[#E4E9F0]
                    py-7
                    flex
                    flex-col
                    md:flex-row
                    md:items-center
                    md:justify-between
                    gap-4
                ">

                    <div>

                        <p className="text-xs text-[#7A8495]">
                            © 2026 Vectors4D
                        </p>

                        <p className="mt-1 text-xs text-[#A0A8B5]">
                            Artificial intelligence research & systems engineering
                        </p>

                    </div>

                    <div className="
                        flex
                        items-center
                        gap-6
                        text-xs
                        text-[#7A8495]
                    ">

                        <Link
                            to="/privacy"
                            className="hover:text-[#172033] transition-colors"
                        >
                            Privacy
                        </Link>

                        <Link
                            to="/terms"
                            className="hover:text-[#172033] transition-colors"
                        >
                            Terms
                        </Link>

                    </div>

                </div>

            </div>
        </footer>
    );
};

export default Footer;